<h5 class="widget-header" *ngIf="(hayRelacionados)"><i class="fas fa-question"></i> Preguntas Relacionadas</h5>
<ul class="btn-toggle-nav list-unstyled fw-normal" *ngFor="let pregunta of preguntasRelacionadas">
  <li *ngIf="pregunta.encontrada=='mismoTema'"><a (click)="responderPregunta(pregunta.id)" class="nav-link-mismoTema"><i class="fas fa-question-circle"></i> {{pregunta.enunciado}}</a></li>
  <li *ngIf="pregunta.encontrada=='mismoHash'"><a (click)="responderPregunta(pregunta.id)" class="nav-link-mismoHash"><i class="fas fa-question-circle"></i> {{pregunta.enunciado}}</a></li>
  <li *ngIf="pregunta.encontrada=='parcialHash'"><a (click)="responderPregunta(pregunta.id)" class="nav-link-parcialHash"><i class="fas fa-question-circle"></i> {{pregunta.enunciado}}</a></li>

</ul>
<app-loading *ngIf="loading" class="m-5"></app-loading>

